import React from 'react';
import {TechseeBaseComponent} from '@techsee/techsee-ui-common/lib/_shared/techsee-base-component';
import {AdvanceScanResultHeader} from './AdvanceScanResultHeader';
import {ScanResultTabs, WifiAnalyzerMode} from '../tabs/ScanResultTabs';
import {IWifiAnalyzerScanController} from '../../controller';
import {observer} from 'mobx-react';

interface AdvanceScanResultContainerProps {
    onClickBack: () => void;
    textButton: string;
    textHeader: string;
    ctrl: IWifiAnalyzerScanController;
}

@observer
export class AdvanceScanResultContainer extends TechseeBaseComponent<AdvanceScanResultContainerProps> {
    renderInternal() {
        const {onClickBack, textButton, textHeader, ctrl} = this.props;

        return (
            <div className={'advance-wifi-analyzer-scan-container'}>
                <AdvanceScanResultHeader
                    onClickBack={onClickBack}
                    textButton={textButton}
                    textHeader={textHeader}></AdvanceScanResultHeader>
                {/*<AdvanceScanResultBox />*/}
                <ScanResultTabs ctrl={ctrl} mode={WifiAnalyzerMode.Session} />
            </div>
        );
    }
}
